import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const SUBSCRIPTION_PLANS_ADMIN = gql`
  query SubscriptionPlansAdmin(
    $filter: SubscriptionPlanFilter
    $sort: SubscriptionPlanSort
  ) {
    subscriptionPlansAdmin(filter: $filter, sort: $sort) {
      data {
        id
        name
        slug
        planId
        price
        type
        config {
          phonePeOneTimePayment
          phonePeRecurringPayment
          razorPayOneTimePayment
          razorPayRecurringCardPayment
          razorPayRecurringUpiPayment
          stripeRecurringCardPayment
        }
        subscriptionFeatures {
          bonusDeliveries
          deliveryCharges
          discount
          memberShipFees
          refundableDeposit
          totalFreeDeliveryPerMonth
          totalKeepCountPerMonth
          toyProgram
          actualChargesForDamageWaiverFees
          actualChargesForSecurityDeposit
          actualChargesForMemberShipFees
          damageWaiverFees
          damageWaiverFeesApplied
          membershipFeesApplied
          securityDepositApplied
          trialAmount
          trialApplied
          trialDays
          isUnlimitedFreeDelivery
          maxToyHoldingValueAllowed
          maxBigToyAllowed
          moneyBackGuarantee
          sameDayDelivery
        }
      }
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const SUBSCRIPTION_PLANS_ADMIN_SELECT = gql`
  query SubscriptionPlansAdmin(
    $filter: SubscriptionPlanFilter
    $sort: SubscriptionPlanSort
  ) {
    subscriptionPlansAdmin(filter: $filter, sort: $sort) {
      count
      data {
        planId
        name
        type
        id
        slug
        isPopular
        price
        subscriptionFeatures {
          memberShipFees
          refundableDeposit
          planVersion
        }
      }
    }
  }
`;
